<template>
  <div>
    <!--  Bộ lọc  -->
    <div>
      <el-row type="flex" :gutter="4">
        <el-col :span="8">
          <el-select
              class="selected_form"
              filterable
              clearable
              v-model="indexForm"
              placeholder="Chọn phiếu"
              @change="handleSearchResultByIdName"
          >
            <el-option
                v-for="(item, index) in forms"
                :key="index"
                :value="index"
                :label="`(FORM_${item.idForm}_${formatDateTimeParseCode(item.createdDate)}) - ${item.nameForm}`"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>

    <div>
      <slot :filter="dataForm"/>
    </div>
  </div>
</template>

<script>

import SurveyForm from "@/services/SurveyForm";

export default {
  data() {
    return {
      indexForm: 0,
      forms: [],
      dataForm: {}
    }
  },

  created() {
    this.fetchDataForms();
  },

  methods: {
    handleSearchResultByIdName(value) {
      this.dataForm = this.forms[value];
    },

    fetchDataForms() {
      SurveyForm.getAllForm()
          .then((res) => {
            const data = res.data.data;
            this.forms = data.reverse();

            this.$emit("firstFetch", {idForm: this.forms[0].idForm, nameForm: this.forms[0].idForm});
          })
          .catch((err) => {
            console.log(err);
          })
    },

    formatDateTimeParseCode(dateStr) {
      const date = new Date(dateStr);

      return `${String(date.getDate()).padStart(2, '0')}${String(date.getMonth() + 1).padStart(2, '0')}${date.getFullYear()}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.selected_form {
  width: 100%;
}

.container_nav_page {
  /deep/ .el-pagination {
    display: flex;
    justify-content: end;
  }
}

.footer_task {
  margin-top: 20px;
}

.menu_task_form {
  background-color: transparent !important;
  display: flex;
  justify-content: end;
  align-content: center;
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 36px;
  line-height: 35px;
  border-bottom: 0 solid transparent;
  border-radius: 4px;
}

/deep/.el-submenu__title i {
  color: #fff;
}
</style>